import type { SVGProps } from "react";
export default function SvgTable(props: SVGProps<SVGSVGElement>) {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="1em"
			height="1em"
			fill="none"
			stroke="currentColor"
			strokeLinecap="round"
			strokeLinejoin="round"
			strokeWidth={2}
			viewBox="0 0 24 24"
			{...props}
		>
			<path d="M12 3v18" />
			<rect width={18} height={18} x={3} y={3} rx={2} />
			<path d="M3 9h18" />
			<path d="M3 15h18" />
		</svg>
	);
}
